export default __webpack_public_path__ + "static/media/home_page.80e39cb8.png";